
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","fill-opacity":".9","stroke":"#fff","stroke-width":"1.5","d":"M39.511 12.153a16 16 0 0 0-1.947-.432c-1.2-.195-2.517-.287-3.926-.287h-11.9a1.897 1.897 0 0 0-1.876 1.606l-2.531 16.033-.073.468a2.16 2.16 0 0 1 2.138-1.832h4.454c8.749 0 15.598-3.553 17.6-13.83q.089-.457.156-.891a10.7 10.7 0 0 0-1.646-.694 14 14 0 0 0-.449-.141Z"}}),_c('path',{attrs:{"fill":"#fff","fill-opacity":".67","d":"M21.13 11.535a1.9 1.9 0 0 0-1.268 1.505l-2.531 16.033-.072.468a2.16 2.16 0 0 1 2.137-1.832h4.454c8.748 0 15.598-3.553 17.6-13.83q.089-.454.155-.886l.307.17a7.4 7.4 0 0 1 1.85 1.494c1.935 2.206 2.314 5.343 1.582 9.1-1.75 8.992-7.742 12.099-15.396 12.1h-1.182a1.9 1.9 0 0 0-1.878 1.605l-.095.518-1.488 9.44-.077.4a1.9 1.9 0 0 1-1.878 1.602h-7.9a1.14 1.14 0 0 1-1.124-1.317l2.926-18.562.073-.468 2.531-16.033a1.9 1.9 0 0 1 1.274-1.507"}}),_c('path',{attrs:{"fill":"#fff","d":"M19.862 13.04a1.89 1.89 0 0 1 1.876-1.604h11.9c1.41 0 2.725.092 3.926.286q.514.083 1.002.19a16 16 0 0 1 1.395.382q.887.293 1.646.694c.596-3.799-.004-6.385-2.058-8.727C37.284 1.683 33.197.579 27.969.579H12.785a2.17 2.17 0 0 0-2.144 1.834L4.318 42.496a1.304 1.304 0 0 0 1.287 1.508h9.373l2.353-14.931z"}})])
          )
        }
      }
    